import React from 'react'
import {FlyersDigitales} from "../components/marketing/FlyersDigitales";

export const FlyersDigitalesPage = () => {
    return (
        <FlyersDigitales/>
    )
}
